import { NAME as PARENT_NAME } from 'constants';

export const NAME = `${PARENT_NAME}/PAYMENTS`;

export const FORM_NAME = 'PAYMENT';

export const SECURITY_CODE_FORM_NAME = 'PAYMENT_SECURITY_CODE';

export const REDUCER_NAME = 'payments';

export const PAYMENT_METHODS = {
  CREDIT_CARD: 'CREDIT_CARD',
  SAVED_CARD: 'SAVED_CARD',
  CREDIT_TERMS: 'CREDIT_TERMS',
};
